import api from "./api";

const scheduleService = {
  // Schedule Change Requests
  getScheduleRequests: (params) => api.get("/schedules/requests", { params }),

  getScheduleRequestById: (id) => api.get(`/schedules/requests/${id}`),

  createScheduleRequest: (requestData) =>
    api.post("/schedules/requests", requestData),

  updateScheduleRequest: (id, requestData) =>
    api.put(`/schedules/requests/${id}`, requestData),

  deleteScheduleRequest: (id) => api.delete(`/schedules/requests/${id}`),

  // Approve/Reject requests
  approveScheduleRequest: (id, data) =>
    api.post(`/schedule/requests/${id}/approve`, data),

  rejectScheduleRequest: (id, data) =>
    api.post(`/schedule/requests/${id}/reject`, data),

  // Get requests by status
  getPendingRequests: () =>
    api.get("/schedule/requests", { params: { status: "pending" } }),

  getApprovedRequests: () =>
    api.get("/schedule/requests", { params: { status: "approved" } }),

  getRejectedRequests: () =>
    api.get("/schedule/requests", { params: { status: "rejected" } }),

  // Teacher's own requests
  getMyScheduleRequests: () => api.get("/schedule/requests/my"),

  // Swap requests
  getSwapRequests: (teacherId) =>
    api.get(`/schedule/swap-requests/${teacherId}`),

  acceptSwapRequest: (requestId) =>
    api.post(`/schedule/swap-requests/${requestId}/accept`),

  declineSwapRequest: (requestId) =>
    api.post(`/schedule/swap-requests/${requestId}/decline`),

  // Timetable - backend exposes schedules at `/schedules`
  getTimetable: (params) => api.get("/schedules", { params }),

  // The backend resolves teacher/class based on the authenticated user.
  // Keep these helpers but route them to the same `/schedules` endpoint.
  getTeacherTimetable: (teacherId, params) =>
    api.get(`/schedules`, { params }),

  getClassTimetable: (classId, params) =>
    api.get(`/schedules`, { params }),

  // Available slots
  getAvailableSlots: (date, params) =>
    api.get(`/schedule/available-slots/${date}`, { params }),

  checkSlotConflict: (data) => api.post("/schedule/check-conflict", data),
};

export default scheduleService;
